import { HashRouter as Router, Redirect, Switch } from "react-router-dom";
import { PublicRoute } from "./PublicRoute";
import { PrivateRoute } from "./PrivateRoute";
import { AuthRuouter } from "./AuthRuouter";
import { MotoclickRouter } from "./MotoclickRouter";
import { useDispatch, useSelector } from "react-redux";
import { Suspense, useEffect } from "react";
import { startChecking } from "../actions/auth/auth";
import { setUserCity } from "../actions/ui/ui";
import { Spinner } from "../components/customComponent/Spinner";
import { getLocalStorage } from "../helpers/localStorage";

const MainLoading = () => {
  return (
    <div className="loading-map d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <h3>Espere por favor</h3>
        <span>
          <Spinner /> Cargando...
        </span>
      </div>
    </div>
  );
};

export const AppRouter = () => {
  const dispatch = useDispatch();
  const { checking, uid, cityId, role, merchantId } = useSelector((state) => state.auth);
  // const data = useSelector((state) => state.auth);
  // console.log(data);

  useEffect(() => {
    if (checking) dispatch(startChecking());
  }, [dispatch, checking]);

  useEffect(() => {
    if (uid && cityId && !localStorage.getItem("city")) {
      dispatch(setUserCity(cityId));
    }
  }, [dispatch, uid, cityId]);

  if (checking) {
    const token = getLocalStorage("token-adm");
    if (token) {
      return <MainLoading />;
    }
  }

  return (
    <Suspense fallback={<MainLoading />}>
      <Router>
        <div>
          <Switch>
            <PublicRoute
              isAutenticated={!!uid}
              path="/auth"
              component={AuthRuouter}
              userRole={role}
              merchantId={merchantId}
            />
            <PrivateRoute
              isAutenticated={!!uid}
              path="/"
              component={MotoclickRouter}
              userRole={role}
              merchantId={merchantId}
            />
            <Redirect to="/auth/login" />
          </Switch>
        </div>
      </Router>
    </Suspense>
  );
};
